/**
 * Status value each Home "pending" card sends to its page. It must equal the `filterValue` of
 * that page's own "Pendientes" KPI card, so the list is filtered and the card highlighted.
 */
export const HOME_PENDING_STATUS_FILTER = {
  records: 'pending',
  transfers: 'Pendiente',
  requests: 'Pendiente',
} as const;
